import { canais } from "../utils/canais"

/**
 * Deriva o tipo do contato com base no canalTipoId.
 * @param {Object} oContato - Objeto do contato
 * @returns {string} "usuario" para canal interno, "contato" para canais externos
 */
export const getTipoContato = (oContato) => {
  if (!oContato) return "contato"
  return oContato.tipo || (oContato.canalTipoId === canais.interno ? "usuario" : "contato")
}

/**
 * Compara dois contatos para verificar se representam o mesmo item selecionável.
 * Com ordenarPorUltimaMensagem, a API pode retornar várias linhas com o mesmo id de contato
 * (conversas abertas em conexões diferentes); nesses casos usa conversaId ou canalId.
 * @param {Object} oPrimeiroContato - Primeiro contato
 * @param {Object} oSegundoContato - Segundo contato
 * @returns {boolean} true se são o mesmo contato/conversa
 */
export const isMesmoContato = (oPrimeiroContato, oSegundoContato) => {
  if (!oPrimeiroContato || !oSegundoContato) return false
  if (oPrimeiroContato.id !== oSegundoContato.id) return false
  if (getTipoContato(oPrimeiroContato) !== getTipoContato(oSegundoContato)) return false

  const nConversaPrimeiro = oPrimeiroContato.conversaId ?? null
  const nConversaSegundo = oSegundoContato.conversaId ?? null
  if (nConversaPrimeiro != null && nConversaSegundo != null) {
    return nConversaPrimeiro === nConversaSegundo
  }

  const nCanalPrimeiro = oPrimeiroContato.canalId ?? null
  const nCanalSegundo = oSegundoContato.canalId ?? null
  if (nCanalPrimeiro != null && nCanalSegundo != null) {
    return nCanalPrimeiro === nCanalSegundo
  }

  return true
}

/**
 * Gera chave estável para listas de contatos/conversas.
 * @param {Object} oContato - Contato ou linha de conversa
 * @returns {string} Chave única para React key
 */
export const getChaveContatoLista = (oContato) => {
  if (!oContato) return "contato-indefinido"
  const cTipoContato = getTipoContato(oContato)
  if (oContato.conversaId != null) {
    return `${cTipoContato}-conversa-${String(oContato.conversaId)}`
  }
  if (oContato.canalId != null) {
    return `${cTipoContato}-${String(oContato.id)}-canal-${String(oContato.canalId)}`
  }
  return `${cTipoContato}-${String(oContato.id)}`
}
